import { FormInput, SubmitButton, PasswordInput } from "@/components/ui";
import { motion } from "framer-motion";

interface ForgotPasswordStep2Props {
  resetCode: string;
  firstPassword: string;
  secondPassword: string;
  error: string | null;
  onBack: () => void;
  onResetCodeChange: (code: string) => void;
  onFirstPasswordChange: (password: string) => void;
  onSecondPasswordChange: (password: string) => void;
  onSubmit: () => void;
  onSandNewCode: () => void;
  firstPasswordError: string | null;
  secondPasswordError: string | null;
  firstPasswordVisible: boolean;
  secondPasswordVisible: boolean;
  setFirstPasswordVisible: (visible: boolean) => void;
  setSecondPasswordVisible: (visible: boolean) => void;
  time: number;
}

export const ForgotPasswordStep2: React.FC<ForgotPasswordStep2Props> = ({
  resetCode,
  firstPassword,
  secondPassword,
  error,
  time,
  onResetCodeChange,
  onFirstPasswordChange,
  onSecondPasswordChange,
  onSubmit,
  onSandNewCode,
  firstPasswordError,
  secondPasswordError,
  firstPasswordVisible,
  secondPasswordVisible,
  setFirstPasswordVisible,
  setSecondPasswordVisible,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="h-full"
    >
      <div className="flex flex-col gap-2 w-full px-4">
        <p className="text-white text-base mb-2 text-center">
          Код для сброса пароля
        </p>
        <FormInput
          id="email"
          label="Ваш код"
          type="number"
          value={resetCode}
          onChange={onResetCodeChange}
          error={null}
        />
        <button
          disabled={time!==0}
          className="text-white text-sm mb-2 text-center cursor-pointer"
          onClick={onSandNewCode}
        >
          {time!==0 ? time : "Отправить код еще раз"}
        </button>

        <p className="text-white text-base mb-2 text-center">
          Введите новый пароль
        </p>

        <PasswordInput
          id="password1"
          label="Пароль"
          value={firstPassword}
          onChange={onFirstPasswordChange}
          error={firstPasswordError}
          visible={firstPasswordVisible}
          onToggleVisibility={() =>
            setFirstPasswordVisible(!firstPasswordVisible)
          }
        />

        <PasswordInput
          id="password2"
          label="Повторите пароль"
          value={secondPassword}
          onChange={onSecondPasswordChange}
          error={secondPasswordError}
          visible={secondPasswordVisible}
          onToggleVisibility={() =>
            setSecondPasswordVisible(!secondPasswordVisible)
          }
        />
        <div className="flex flex-col justify-end h-[80px]">
          <p className="text-red-500 text-sm mb-2 text-center">{error}</p>
          <SubmitButton
            text="Продолжить"
            onClick={onSubmit}
            disabled={!firstPassword || !secondPassword}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default ForgotPasswordStep2;
